<template>
  <div>
    <add-Button
      :height="'80px'"
      :add-text="'新增企业账户'"
      @click.native="openAccountFormDialog(initAccountForm)"
    ></add-Button>

    <div v-for="item in bankAccountList" :key="item.id">
      <div class="account-table-item">
        <div class="title">
          <p>{{item.bankAccountName}}</p>
          <span>{{item.bankBranchName}}</span>
        </div>
        <div class="account-number">
          <label>银行账号</label>
          <p>{{item.bankAccountNumber}}</p>
        </div>
        <div class="account-name">
          <p>{{item.bankName}}</p>
        </div>
        <div class="account-action">
          <el-button type="text" @click="modifyBankAccount(item)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" class="delete" @click="deleteBankAccount(item.id)">删除</el-button>
        </div>
      </div>
      <el-divider />
    </div>

    <Page
      :total="total"
      :current="pagination.from"
      :page-size="pagination.size"
      @on-change="setPaginationFrom"
    />

    <!-- 修改增加企业账户弹窗 -->
    <el-dialog
      :title="submitAccountFormConfig.tooltip"
      :visible.sync="dialogVisible"
      width="575px"
      :before-close="handleClose"
    >
      <el-form
        :model="accountForm"
        :rules="rules"
        ref="accountForm"
        label-width="80px"
        label-position="left"
      >
        <el-form-item label="开户名" prop="bankAccountName">
          <el-input v-model="accountForm.bankAccountName"></el-input>
        </el-form-item>

        <el-form-item label="企业账号" prop="bankAccountNumber">
          <bank-account v-model="accountForm.bankAccountNumber" ref="bankAccountNumber" />
        </el-form-item>

        <el-form-item label="开户行" class="not-required" prop="bankName">
          <bank-account-type
            v-model="accountForm.bankName"
            class="bank-account-type"
            ref="bankAccountType"
          />
        </el-form-item>

        <el-form-item label="开户支行" prop="bankBranchName">
          <el-input v-model="accountForm.bankBranchName"></el-input>
        </el-form-item>

        <el-form-item label="所在地" class="not-required" prop="selectedCity">
          <city-picker class="city-picker" ref="cityPicker" v-model="accountForm.selectedCity" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmitAccountForm">取 消</el-button>
        <el-button type="primary" @click="confirmSubmitAccountForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AddButton from "@/components/AddButton/AddButton";
import CityPicker from "@/components/business/CityPicker";
import BankAccount from "@/components/BankAccount/BankAccount";
import BankAccountType from "@/components/BankAccount/BankAccountType";

import {
  enterpriseBankAccountValidator,
  cityPickerValidator
} from "@/validator/validator";

const columnTitles = [
  { title: "开户名", key: "bankAccountName", align: "center", minWidth: 100 },
  {
    title: "开户账号",
    key: "bankAccountNumber",
    align: "center",
    minWidth: 100
  },
  { title: "开户行", key: "bankName", align: "center", minWidth: 100 },
  { title: "操作", slot: "action", align: "center", minWidth: 100 }
];

const initEnterpriseBankAccount = {
  bankAccountName: "",
  bankAccountNumber: "",
  bankName: "",
  bankBranchName: "",
  selectedCity: {
    provinceId: "",
    cityId: "",
    areaId: ""
  }
};

export default {
  components: {
    AddButton,
    CityPicker,
    BankAccount,
    BankAccountType
  },
  computed: {
    submitAccountFormConfig() {
      if (this.accountForm.id) {
        return {
          api: this.$api.editEnterpriseBankAccount,
          tooltip: "修改"
        };
      } else {
        return {
          api: this.$api.addEnterpriseBankAccount,
          tooltip: "添加"
        };
      }
    }
  },
  watch: {
    "pagination.from": {
      immediate: true,
      handler(newValue) {
        this.setBankAccountList();
      }
    }
  },
  data() {
    return {
      pagination: {
        from: 1,
        size: 10
      },
      total: 0,

      initAccountForm: this.$js.deepClone(initEnterpriseBankAccount),
      accountForm: this.$js.deepClone(initEnterpriseBankAccount),

      dialogVisible: false,

      rules: {
        bankAccountNumber: enterpriseBankAccountValidator(),
        bankAccountName: [
          { required: true, message: "开户名不能为空", trigger: "blur" },
        ],
        bankBranchName: [
          { required: true, message: "开户支行的名字不能为空", trigger: "blur" }
        ],
        bankName: [
          { required: true, message: "开户行的名字不能为空", trigger: "blur" }
        ],
        selectedCity: cityPickerValidator
      },
      columnTitles: columnTitles,
      bankAccountList: []
    };
  },

  methods: {
    setPaginationFrom(val) {
      this.pagination.from = val;
    },

    setBankAccountList() {
      this.$api.getEnterpriseBankAccountList(this.pagination).then(res => {
        this.bankAccountList = res.records;
        this.total = res.total;
      });
    },

    refreshBankAccountList() {
      if (this.pagination.from !== 1) {
        return (this.pagination.from = 1);
      }
      this.setBankAccountList();
    },

    handleRequestData() {
      Object.assign(
        this.accountForm,
        this.$js.deepClone(this.$refs.cityPicker.selectedCityDetails)
      );
      const bankDetails = this.$refs.bankAccountType.selectedBankDetails;

      if (bankDetails) {
        this.accountForm.bankCode = bankDetails.bankCode;
      }
    },

    modifyBankAccount(bankAccount) {
      const {
        bankAccountName,
        bankAccountNumber,
        bankName,
        bankBranchName,
        provinceId,
        cityId,
        areaId,
        id,
        bankCode
      } = bankAccount;
      const modifyBankAccount = {
        bankAccountName,
        bankAccountNumber,
        bankName,
        bankCode,
        id,
        bankBranchName,
        selectedCity: {
          provinceId: provinceId,
          cityId: cityId,
          areaId: areaId
        }
      };

      this.openAccountFormDialog(modifyBankAccount);
    },

    openAccountFormDialog(bankAccount) {
      this.dialogVisible = true;
      this.accountForm = this.$js.deepClone(bankAccount);
    },

    handleClose(done) {
      this.clearAccountFrom();
      done();
    },

    confirmSubmitAccountForm() {
      this.$refs.accountForm.validate(valid => {
        if (!valid) return false;
        this.submitAccountForm();
      });
    },

    cancelSubmitAccountForm() {
      this.clearAccountFrom();
      this.dialogVisible = false;
    },

    submitAccountForm() {
      this.handleRequestData();

      let accountForm = this.$js.deepClone(this.accountForm);
      accountForm.bankAccountNumber = this.$refs.bankAccountNumber.reallyBankAccount;

      this.submitAccountFormConfig.api(accountForm).then(() => {
        this.$Message.success(`${this.submitAccountFormConfig.tooltip}成功！`);
        this.dialogVisible = false;
        this.clearAccountFrom();
        this.refreshBankAccountList();
      });
    },

    clearAccountFrom() {
      this.accountForm = this.$js.deepClone(this.initAccountForm);
      this.$refs.accountForm.clearValidate();
    },

    deleteBankAccount(id) {
      this.$api.deleteEnterpriseBankAccount(id).then(() => {
        this.$Message.success("删除成功！");
        this.refreshBankAccountList();
      });
    }
  }
};
</script>

<style scoped lang="scss">
.add-button {
  margin-bottom: 20px;
}

.el-divider {
  margin: 10px 0;
}

.account-table-item {
  display: flex;
  $height: 60px;
  position: relative;
  height: $height;
  align-items: center;
  padding: 0 30px;

  .title {
    font-size: 14px;
    line-height: 22px;
    flex: 1;

    p {
      font-weight: 500;
      margin-bottom: 4px;
      color: #515a6e;
    }

    span {
      color: rgba(0, 0, 0, 0.45);
    }
  }

  .account-number {
    font-size: 14px;
    line-height: 22px;
    min-width: 200px;

    label {
      display: inline-block;
      color: #515a6e;
      margin-bottom: 4px;
    }

    p {
      color: #808695;
    }
  }

  .account-name {
    line-height: $height;
    font-size: 14px;
    min-width: 200px;
    text-align: center;
  }

  .account-action {
    width: 120px;
    text-align: right;

    .el-divider {
      height: 14px;
      margin: 0 15px;
    }

    .delete {
      color: #ed4014;
    }
  }
}
.ivu-page {
  float: right;
  margin-top: 25px;
}
.bank-account-type {
  width: 100%;
}

::v-deep .city-picker {
  width: 455px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .province,
  .city,
  .country {
    width: 150px;
  }
}
</style>